var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"banner"},[_c('img',{staticStyle:{"width":"64px","height":"64px"},attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('h1',{staticStyle:{"margin-top":"1rem","font-size":"50px"}},[_vm._v("欢迎进入挑选好医生管理系统")])])])
}]

export { render, staticRenderFns }